( function( $, window, document, undefined ) {

	$(document).ready(function() {
	
		$( '#request_referral' ).on('change', function() {

		  if( this.value == '__other' ){
		  	$( '#request_referral__other' ).css( 'display', 'block' );
		  } else {
		  	$( '#request_referral__other' ).css( 'display', 'none' );
		  }

		});

		$( '#contact_referral' ).on('change', function() {

		  if( this.value == '__other' ){
		  	$( '.js-contact-referral__other' ).css( 'display', 'block' );
		  } else {
		  	$( '.js-contact-referral__other' ).css( 'display', 'none' );
		  }

		});

	});

})( jQuery, window, document );
